import { useState, useEffect } from "react";
import LcFetch from "lib/shared/fetch";

const useDiscussionQuestionsFormPopulator = (formik, selectedTitle) => {
  const [loadingTopics, setLoadingTopics] = useState(false);
  const [topics, setTopics] = useState(selectedTitle?.topics ?? []);
  const [selectedTopic, setSelectedTopic] = useState();
  const [selectedSubtopic, setSelectedSubtopic] = useState();

  // This is a hack for when we submit the form and the topics get set to
  // an empty array when the hook gets re-instantiated. We refetch the dropdown content to populate the topics state.
  useEffect(() => {
    if (selectedTitle?.guide_path) {
      fetchDropdownContent(selectedTitle?.guide_path);
    }
  }, []);

  const fetchDropdownContent = (guidePath) => {
    setTopics([]);
    setSelectedTopic(null);
    setSelectedSubtopic(null);

    const loadingTimeout = setTimeout(() => {
      setTopics([]);
      setLoadingTopics(true);
    }, 1000);

    LcFetch(guidePath, { method: "GET" })
      .then((response) => {
        if (!response.ok) {
          clearTimeout(loadingTimeout);
          setLoadingTopics(false);
          setTopics([]);
          formik.setFieldError(
            "topic",
            "Data request failed. Please try again."
          );
        } else {
          return response.json();
        }
      })
      .then((data) => {
        clearTimeout(loadingTimeout);
        setTopics(data.topics);
        setLoadingTopics(false);
      })
      .catch((error) => {
        clearTimeout(loadingTimeout);
        setLoadingTopics(false);
        setTopics([]);
        formik.setFieldError("topic", "Data request failed. Please try again.");
        console.error("Error fetching dropdown content:", error);
      });
  };

  return {
    fetchDropdownContent,
    loadingTopics,
    selectedSubtopic,
    selectedTopic,
    setSelectedSubtopic,
    setSelectedTopic,
    topics
  };
};

export default useDiscussionQuestionsFormPopulator;
